import { createAction } from 'redux-act';

export const logout = createAction('LOGOUT');
